import {split} from 'lodash';
import {last} from 'lodash';
import generalClient from 'superagent';
import {useTranslation} from 'react-i18next';
import {useSWRTemplate, useSWRPaginationTemplate} from 'hooks/dataHooksTemplate';
import {sortBy} from 'lodash';
import {get} from 'lodash';
import client, {adminClient, saleClient, authClient} from 'helper/httpClient';
import {peekWafToken} from 'utils/HttpClient';
import appSettings from 'config/app';
import {processCurrency} from 'data/curreny';
import {cleanObjectNilValue} from 'utils/clean';
import Excel from 'exceljs';
import { useAuth } from 'hooks/useAuth';

export const api = () => {
    const store = localStorage.getItem(
        `${process.env.REACT_APP_STORE_PREFIX}-authStore`,
    );
    if (store) {
        const state = JSON.parse(store);
        // const isAdminUser = (state?.state?.user?.roles || []).includes('ADMIN');
        const isUser = (state?.state?.user?.roles || []).includes('USER');
        // const isSALE = (state?.state?.user?.roles || []).includes('SALE');
        return isUser ? client : adminClient;
    } else {
        return client;
    }
};

export const getCurrentUserType = () => {
    const store = localStorage.getItem(
        `${process.env.REACT_APP_STORE_PREFIX}-authStore`,
    );
    if (store) {
        const state = JSON.parse(store);
        const isAdmin = (state?.state?.user.roles || []).includes('ADMIN');
        const isSupport = (state?.state?.user.roles || []).includes('DEALER');
        const isUser = (state?.state?.user.roles || []).includes('USER');
        const isSale = (state?.state?.user.roles || []).includes('SALE');
        return {
            isAdmin,
            isUser,
            isSale,
            isSupport,
        };
    } else {
        return {
            isUser,
        };
    }
};

export const useUploader = () => {
    return async (file) => {
        const extension = last(split(file.name, '.'));
        // console.log('file:', file, extension);
        const {
            result: {url, type, accessUrl},
        } = await api().post(['upload-file'], {
            extension,
        });

        await generalClient
            .put(url)
            .set('Access-Control-Allow-Origin', '*')
            .set('Access-Control-Allow-Credentials', 'true')
            .set('x-ms-blob-type', 'BlockBlob')
            // .set('x-amz-acl', 'public-read')
            // .withCredentials()
            .set('Content-Type', type)
            .send(file);

        return accessUrl;
    };
};
export const useUploaderOss = () => {
    return async (file) => {
        const extension = last(split(file.name, '.'));
        // console.log('file:', file, extension);
        const {
            result: {url, type, accessUrl},
        } = await api().post(['upload-file-oss'], {
            extension,
        });

        await generalClient
            .put(url)
            .set('Access-Control-Allow-Origin', '*')
            .set('Access-Control-Allow-Credentials', 'true')
            .set('x-ms-blob-type', 'BlockBlob')
            // .set('x-amz-acl', 'public-read')
            // .withCredentials()
            .set('Content-Type', type)
            .send(file);

        return accessUrl;
    };
};

export const deleteFile = async (id, file) => {
    return await api().del(['user', 'user-files', id], cleanObjectNilValue({ file }))
}

export const useRegion = (options = {}) => {
    const {} = options;
    const {t: countriesI18n} = useTranslation('countries');
    const swr = useSWRTemplate({
        key: ['region'],
        request: async (_) => {
            const {result} = await api().get(['region']);
            return result;
        },
        defaultValue: [],
    });
    const localedCountries = sortBy(
        get(swr, 'data').map((item) => ({
            ...item,
            label: countriesI18n(item.code),
            code: item.code,
            value: item.code,
        })),
        (o) => o.label,
    );
    return {
        ...swr,
        localedCountries,
        restrictedCountries: localedCountries.filter((item) =>
            Boolean(item.isRestricted),
        ),
        cardExcludeCountries: localedCountries.filter((item) =>
            Boolean(item.isCardExclude),
        ),
        registerDisabledCountries: localedCountries.map(item=>{
            return {
                ...item,
                disabled: get(item, 'disabledRegister')
            }
        }),
        adminSettingRestrictedCountries: get(swr, 'data').filter(item=>{
            return get(item, 'isRestricted')
        }),
        adminSettingRiskyCountries: get(swr, 'data').filter(item=>{
            return get(item, 'riskRegion')
        }),
        adminSettingRegions: get(swr, 'data').filter(item=>{
            return !get(item, 'isRestricted') && !get(item, 'riskRegion')
        }),
    };
};

export const useRegionByCode = (code) => {
    const {isAdmin} = useAuth()
    const swr = useSWRTemplate({
        key: code ? ['region-by-id', code] : null,
        request: async ([_, _code]) => {
            const {result} = await api().get(isAdmin ? ['setting', 'restricted-region', _code]: ['region-by-id', _code]);
            return result;
        },
        defaultValue: [],
    });
    return swr
};

export const usePageRegions = () => {
    const swr = useSWRPaginationTemplate({
        key: ['restricted-region'],
        request: async (_key, _pageIndex, _pageSize) => {
            const query = {
                pageIndex: _pageIndex - 1,
                pageSize: _pageSize
            }
            const  {result} = await api().get(['setting', 'restricted-region'], query);
            return {
                result: {
                    items: get(result, 'items'),
                    totalItems: get(result, 'totalItems'),
                }
            }
        },
        defaultValue: { items: [], totalItems: 0 }
    })
    return {
        ...swr
    }
}

export const downloadRegions = async (t=()=>{}, countriesT=()=>{}) => {
    const {result} = await api().get(['region']);
    if(!result.length) {
        throw new Error('Can not export empty data')
    }

    const workbook = new Excel.Workbook();
    const sheet = workbook.addWorksheet('Regions');
    sheet.columns = [
        {header: 'Country', key: 'country'},
        {header: 'Code', key: 'code'},
        {header: 'Risky region', key: 'riskRegion'},
        {header: 'Restricted', key: 'restricted'},
    ];

    for (const grant of result) {
        const row = [];
        for (const col of sheet.columns) {
            switch (col.key) {
                case 'country':
                    row.push(countriesT(get(grant, 'code')));
                    break;
                case 'code':
                    row.push(grant.code);
                    break;
                case 'riskRegion':
                    if(grant.riskRegion){
                        row.push(grant.riskRegion);
                    }else{
                        row.push('');
                    }
                    break;
                case 'restricted':
                    if(grant.riskRegion){
                        row.push('');
                    }else{
                        if(grant.isRestricted){
                            row.push(t('yes'));
                        }else{
                            row.push('');
                        }
                    }
                    break;
            }
        }
        sheet.addRow(row);
    }

    const buffer = await workbook.xlsx.writeBuffer();
    let a = window.document.createElement('a');
    a.href = URL.createObjectURL(
        new Blob([buffer], {type: 'application/vnd.openxmlformats'}),
    );
    a.download = `Regions.xlsx`;
    window.document.body.appendChild(a);
    a.click();
    window.document.body.removeChild(a);
};


export const downloadThreeRegions = async (
    regions = [],
    risky = [],
    restricted = [],
    t=()=>{}, countriesT=()=>{}
) => {
    const workbook = new Excel.Workbook();
    const riskColumns = [
        {header: 'Country', key: 'country'},
        {header: 'Code', key: 'code'},
        {header: 'Risky region', key: 'riskRegion'},
    ];
    const regionColumns = [
        {header: 'Country', key: 'country'},
        {header: 'Code', key: 'code'},
    ];
    const restrictedColumns = [
        {header: 'Country', key: 'country'},
        {header: 'Code', key: 'code'},
    ];
    let sheet, sheet2, sheet3;

    sheet = workbook.addWorksheet('Regions');
    sheet.columns = regionColumns;
    for (const grant of regions) {
        const row = [];
        for (const col of sheet.columns) {
            switch (col.key) {
                case 'country':
                    row.push(countriesT(get(grant, 'code')));
                    break;
                case 'code':
                    row.push(grant.code);
                    break;
            }
        }
        sheet.addRow(row);
    }
    sheet2 = workbook.addWorksheet('Risky regions');
    sheet2.columns = riskColumns;
    for (const grant of risky) {
        const row = [];
        for (const col of sheet2.columns) {
            switch (col.key) {
                case 'country':
                    row.push(countriesT(get(grant, 'code')));
                    break;
                case 'code':
                    row.push(grant.code);
                    break;
                case 'riskRegion':
                    row.push(grant.riskRegion);
                    break;
            }
        }
        sheet2.addRow(row);
    }
    sheet3 = workbook.addWorksheet('Restricted regions');
    sheet3.columns = restrictedColumns;
    for (const grant of restricted) {
        const row = [];
        for (const col of sheet3.columns) {
            switch (col.key) {
                case 'country':
                    row.push(countriesT(get(grant, 'code')));
                    break;
                case 'code':
                    row.push(grant.code);
                    break;
            }
        }
        sheet3.addRow(row);
    }

    const buffer = await workbook.xlsx.writeBuffer();
    let a = window.document.createElement('a');
    a.href = URL.createObjectURL(
        new Blob([buffer], {type: 'application/vnd.openxmlformats'}),
    );
    a.download = `Regions.xlsx`;
    window.document.body.appendChild(a);
    a.click();
    window.document.body.removeChild(a);
};

export const usePersonTitle = (options = {}) => {
    const {} = options;
    const {t} = useTranslation('personTitle');
    const swr = useSWRTemplate({
        key: ['person-title'],
        request: async (_) => {
            const {result} = await api().get(['commons', 'person-title']);
            return result;
        },
        defaultValue: [],
    });
    const localedTitle = sortBy(
        get(swr, 'data').map((item) => ({
            ...item,
            label: t(item.code),
            code: item.code,
            value: item.code,
        })),
        (o) => o.label,
    );
    return {
        ...swr,
        localedTitle,
    };
};

export const useOccupation = (options = {}) => {
    const {} = options;
    const {t} = useTranslation('app');
    const swr = useSWRTemplate({
        key: ['person-occupation'],
        request: async (_) => {
            const {result} = await api().get(['commons', 'person-occupation']);
            return result;
        },
        defaultValue: [],
    });
    const localedOccupation = sortBy(
        get(swr, 'data').map((item) => ({
            ...item,
            label: t(item.name),
            code: item.code,
            value: item.code,
        })),
        (o) => o.label,
    );
    return {
        ...swr,
        localedOccupation,
    };
};

export const useCompanyIndustry = (options = {}) => {
    const {} = options;
    const {t} = useTranslation('app');
    const swr = useSWRTemplate({
        key: ['company-industry'],
        request: async (_) => {
            const {result} = await api().get(['commons', 'company-industry']);
            return result;
        },
        defaultValue: [],
    });
    const localedIndustry = sortBy(
        get(swr, 'data').map((item) => ({
            ...item,
            label: t(item.name),
            code: item.code,
            value: item.code,
        })),
        (o) => o.label,
    );
    return {
        ...swr,
        localedIndustry,
    };
};

export const usePhoneCode = (options = {}) => {
    const {} = options;
    return useSWRTemplate({
        key: ['phone-code'],
        request: async (_) => {
            const {result} = await api().get(['phone-code']);
            return result.map((item) => ({
                value: `+${item.phoneCode}`,
                label: `+${item.phoneCode}`,
            }));
        },
        defaultValue: [],
    });
};

export const useCurrency = (options = {}) => {
    const {} = options;
    const {t: currencyT} = useTranslation('currencies');
    const swr = useSWRTemplate({
        key: ['currency'],
        request: async (_) => {
            const {result} = await api().get(['currency-list']);
            return result.map(processCurrency);
        },
        defaultValue: [],
    });
    const localedCurrency = sortBy(
        get(swr, 'data').map((item) => ({
            ...item,
            label: currencyT(item.code) + ` (${item.code})`,
            code: item.code,
            value: item.code,
        })),
        (o) => o.label,
    );
    const platformCurrencyOrder = [
        'EUR',
        'GBP',
        'AUD',
        'NZD',
        'USD',
        'CAD',
        'JPY',
        'SGD',
        'HKD',
    ];
    const withdrawalCurrencyOrder = [
        'EUR',
        'GBP',
        'AUD',
        'NZD',
        'USD',
        'CAD',
        'PHP',
        'SGD',
        'KRW'
        // 'HKD',
    ];
    const platformCurrency = localedCurrency
        .filter((item) => item.isMT4Support)
        .sort(
            (a, b) =>
                platformCurrencyOrder.indexOf(a.code) -
                platformCurrencyOrder.indexOf(b.code),
        );
    const withdrawalCurrency = localedCurrency.filter(item=> withdrawalCurrencyOrder.includes(item.code))
    return {
        ...swr,
        localedCurrency,
        platformCurrency,
        withdrawalCurrency,
        updateCurrency_: async (id, data) => {
            const {result} = await api().put(
                ['currency', id],
                cleanObjectNilValue(data),
            );
            return result;
        },
    };
};

export const useStates = (options = {}) => {
    const {country} = options;
    const {t} = useTranslation('app');
    const swr = useSWRTemplate({
        key: country ? ['state', country] : null,
        request: async ([_, _country]) => {
            const {result} = await api().get(['commons', 'state'], {
                countryCode: _country,
            });
            return result;
        },
        defaultValue: [],
    });
    const localedStates = sortBy(
        get(swr, 'data').map((item) => ({
            ...item,
            label: item.name + ` (${item.isoCode})`,
            code: item.isoCode,
            value: item.isoCode,
        })),
        (o) => o.label,
    );
    return {
        ...swr,
        localedStates,
    };
};
export const useCities = (options = {}) => {
    const {state, country} = options;
    // const {t} = useTranslation('app');
    const swr = useSWRTemplate({
        key: state && country ? ['city', state, country] : null,
        request: async ([_, _state, _country]) => {
            const {result} = await api().get(['commons', 'city'], {
                stateCode: _state,
                countryCode: _country,
            });
            return result;
        },
        defaultValue: [],
    });
    const localedCities = sortBy(
        get(swr, 'data').map((item) => ({
            ...item,
            label: item.name,
            code: item.name,
            value: item.name,
        })),
        (o) => o.label,
    );
    return {
        ...swr,
        localedCities,
    };
};

export const useCurrencyCutOffTime = (options = {}) => {
    const swr = useSWRTemplate({
        key: ['currency-cut-off-time'],
        request: async ([_]) => {
            const {result} = await api().get([
                'commons',
                'currency-cut-off-time',
            ]);
            return result;
        },
        defaultValue: [],
    });
    return swr;
};

export const sendVerifyCode_ = async ({method, issueId, mobile=null, nextMethod=null}) => {
    const {result} = await api().post(['verify-code'], cleanObjectNilValue({
        method,
        issueId,
        mobile,
        nextMethod
    }));
    return result;
};

export const verifyEmailCode_ = async (data) => {
    const {result} = await api().post(
        ['verify-email'],
        cleanObjectNilValue(data),
    );
    return result;
};

export const verifyOtpCode_ = async (data) => {
    const {result} = await api().post(
        ['verify-otp'],
        cleanObjectNilValue(data),
    );
    return result;
};


export const downloadFile_ = async (
    blobFile,
    name = 'template.xlsx',
    type = 'application/vnd.openxmlformats',
) => {
    let a = window.document.createElement('a');
    a.href = URL.createObjectURL(new Blob([blobFile], {type}));
    a.download = name;
    window.document.body.appendChild(a);
    a.click();
    window.document.body.removeChild(a);
};

export const useCryptoNetwork = (options = {}) => {
    return useSWRTemplate({
        key: ['CryptoNetwork'],
        request: async ([_]) => {
            const {result} = await api().get(['commons', 'crypto-type'], {
                code: 'USDT',
            });
            return result;
        },
        defaultValue: {},
    });
};

export const useCanRegister = (referralCode = '') => {
    return useSWRTemplate({
        key: ['can-register', referralCode],
        request: async ([_, _referralCode]) => {
            const {result} = await authClient.get(
                ['restrictions', 'registration'],
                _referralCode ? {referralCode: _referralCode} : undefined,
            );
            return result
        },
        defaultValue: { allowed: true }
    })
}

export const useImageCaptchaSetting = () => {
    return useSWRTemplate({
        key: ['image-captcha-setting'],
        request: async (_) => {
            const {result} = await authClient.get(['image-captcha-setting']);
            return result
        },
        defaultValue: { enable: false }
    })
}

export const signDocUrl_ = async (data) => {
    const {result} = await api().post(
        ['sign-doc-url'],
        cleanObjectNilValue(data),
    );
    return result;
};

// Backend-rendered KYC PDF export: the Service renders the kyc-export print
// page with puppeteer and streams back the PDF; trigger a browser download.
export const downloadKycPdf_ = async ({id, sections, hideFields, filename}) => {
    const store = localStorage.getItem(
        `${process.env.REACT_APP_STORE_PREFIX}-authStore`,
    );
    const token = store ? JSON.parse(store)?.state?.token : null;
    const params = new URLSearchParams({
        sections: sections.join(','),
    });
    if (hideFields && hideFields.length) {
        params.set('hideFields', hideFields.join(','));
    }
    const wafToken = await peekWafToken();
    const response = await fetch(
        `${appSettings.adminApiEndpoint}/kyc-pdf/${id}?${params}`,
        {
            credentials: window.withCredentials ? 'include' : 'same-origin',
            headers: {
                ...(token ? {Authorization: `Bearer ${token}`} : {}),
                ...(wafToken ? {'x-aws-waf-token': wafToken} : {}),
            },
        },
    );
    if (!response.ok) {
        throw new Error(`kyc pdf export failed: ${response.status}`);
    }
    const blob = await response.blob();
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
};
